import { useRef, type PointerEvent } from "react";
import CnbLink from "@core/layouts/header/components/common/CnbLink";
import { useCnbConfig } from "@core/hooks/useCnbConfig";
import { cn } from "@core/utils/domUtil";

export default function CnbPc({ isOpen, pointerOverHandler }: { isOpen: boolean; pointerOverHandler: (e: PointerEvent<HTMLAnchorElement>) => void }) {
  const { data, activeIndex } = useCnbConfig() ?? {};
  const cnbWarpRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div ref={cnbWarpRef}>
        <ul className="header-xl:gap-[40px] flex gap-[20px]">
          {Array.isArray(data?.menu) &&
            data?.menu.map((item, i) => (
              <li key={`${item.name}-${i}`}>
                <CnbLink type="pc" depth="depth1" data={item} onPointerOver={pointerOverHandler} isActive={i === activeIndex?.[0]} />
                {Array.isArray(item.children) && item.children.length > 0 && (
                  <div className={cn("depth2-wrap absolute top-[var(--pc-header-height)] z-10 mt-[17px]", isOpen && "block")}>
                    <ul className="pl-[10px]">
                      {item.children.map((childrenItem, j) => (
                        <li key={`${childrenItem.name}-${j}`} className="my-[10px]">
                          <CnbLink type="pc" depth="depth2" data={childrenItem} isActive={i === activeIndex?.[0] && j === activeIndex?.[1]} />
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            ))}
        </ul>
      </div>
    </>
  );
}
